const BarChartIcon = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="48"
                height="48"
                rx="4"
                fill="#17C289"
                fillOpacity="0.11"
            ></rect>
            <rect x="15" y="26" width="4" height="7" rx="1" fill="#17C289"></rect>
            <rect x="21" y="22" width="4" height="11" rx="1" fill="#17C289"></rect>
            <rect x="27" y="18" width="4" height="15" rx="1" fill="#17C289"></rect>
            <path
                d="M16 24L22 20L28 22L33 16"
                stroke="#17C289"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <circle cx="33" cy="16" r="1.5" fill="#17C289"></circle>
        </svg>
    );
};

export default BarChartIcon;
